import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppToaster } from './app/AppToaster';
import { createRemoteContainer } from './app/remote-container';
import { ErrorBoundary } from './app/ErrorBoundary';
import { AppRouter } from './app/router';
import { registerServiceWorker } from './app/register-service-worker';
import { AppProviders } from './features/session/session-provider';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';
import '@fontsource/ibm-plex-sans-condensed/400.css';
import '@fontsource/ibm-plex-sans-condensed/500.css';
import '@fontsource/ibm-plex-sans-condensed/600.css';
import './styles/index.css';

const rootElement = document.getElementById('root');
if (rootElement === null) throw new Error('Elemento #root não encontrado.');

// A aplicação fala com o servidor. O container local continua existindo por dentro —
// perfil ativo, obra aberta e o segredo da sessão são estado do aparelho —, mas o que é
// da obra vem da rede (ver app/remote-container.ts).
const container = createRemoteContainer();

registerServiceWorker();

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <AppProviders container={container}>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <AppToaster />
      </AppProviders>
    </ErrorBoundary>
  </StrictMode>,
);
